const PADDLE_SCRIPT_ID = 'paddle-js-v2';
const PADDLE_SCRIPT_SRC = 'https://cdn.paddle.com/paddle/v2/paddle.js';

let initPromise = null;

function loadPaddleScript() {
  return new Promise((resolve, reject) => {
    if (window.Paddle) {
      resolve(window.Paddle);
      return;
    }

    const existing = document.getElementById(PADDLE_SCRIPT_ID);
    if (existing) {
      existing.addEventListener('load', () => resolve(window.Paddle), { once: true });
      existing.addEventListener('error', reject, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.id = PADDLE_SCRIPT_ID;
    script.src = PADDLE_SCRIPT_SRC;
    script.async = true;
    script.onload = () => resolve(window.Paddle);
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

export async function getPaddle() {
  if (window.__paydaaiPaddleInitialized && window.Paddle) {
    return window.Paddle;
  }

  if (initPromise) return initPromise;

  initPromise = (async () => {
    const token = process.env.REACT_APP_PADDLE_CLIENT_TOKEN;
    if (!token) {
      throw new Error('Paddle checkout is not configured yet.');
    }

    const Paddle = await loadPaddleScript();
    if (!Paddle) throw new Error('Paddle.js failed to load.');

    if (process.env.REACT_APP_PADDLE_ENV === 'sandbox') {
      Paddle.Environment.set('sandbox');
    }

    Paddle.Initialize({
      token,
      // Sayfalar Paddle olaylarını 'paddle:event' penceresi olayıyla dinleyebilir.
      eventCallback: (event) => {
        try { window.dispatchEvent(new CustomEvent('paddle:event', { detail: event })); } catch (e) { /* yok say */ }
      },
      checkout: {
        settings: {
          displayMode: 'overlay',
          theme: 'light',
          locale: 'en',
          showAddDiscounts: true,
        },
      },
    });

    window.__paydaaiPaddleInitialized = true;
    return Paddle;
  })();

  try {
    return await initPromise;
  } catch (err) {
    initPromise = null;
    throw err;
  }
}
